import { useEffect, useMemo, useState } from "react";
import {
  DEBOUNCE_DELAY

} from "src/constants/globalConstants";
import { useComponentDidMount } from "src/hooks/useComponentDidMount";
import { useDebounce } from "src/hooks/useDebounce";
import { useUsers } from "./useUsers";

export const useUserFilter = () => {
  const [pageSize, setPageSize] = useState(12);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const debouncedSearchTerm = useDebounce({
    searchQuery: searchTerm,
    delay: DEBOUNCE_DELAY,
  });
  const isComponentMounted = useComponentDidMount();

  const {
    isLoading: isPermissionLoading,
    mutate,
    meta,
    error,
    users,
    ...rest
  } = useUsers({
    page,
    limit: pageSize,
    searchTerm: debouncedSearchTerm,
  });

  useEffect(() => {
    isComponentMounted && page !== 1 && setPage(1);
  }, [debouncedSearchTerm]);

  const isLoading = useMemo(() => {
    return isPermissionLoading;
  }, [isPermissionLoading]);


  const total = useMemo(() => {
    return meta?.total || 0;
  }, [meta]);

  const showResetAllButton = useMemo(() => {
    return  !!debouncedSearchTerm;
  },  [debouncedSearchTerm]);

  const onReset = () => {
    setSearchTerm("");
  };
  return {
    isLoading,
    meta,
    users,
    error,
    showResetAllButton,
    onReset,
    total,
    setPageSize,
    searchTerm,
    setSearchTerm,
    page,
    setPage,
    pageSize,
    ...rest,
    mutate,
  };
};
